import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { EncrDecrService } from './services/encr-decr.service';

import {  CommonModule,  LocationStrategy,  PathLocationStrategy} from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { Routes, RouterModule } from '@angular/router';
import { FullComponent } from './layouts/full/full.component';
import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';
import { LoginComponent } from './login/login.component';
import { DataTablesModule } from 'angular-datatables';
import { InputFileConfig, InputFileModule } from 'ngx-input-file';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { ModalModule, SortableModule, CollapseModule, BsDropdownModule } from 'ngx-bootstrap';
import { CustomerComponent } from './customer/customer.component';
import { CustomerListComponent } from './customer/customer-list/customer-list.component';
import { AddCustomerComponent } from './customer/add-customer/add-customer.component';
import { EditCustomerComponent } from './customer/edit-customer/edit-customer.component';
import { SignupComponent } from './signup/signup.component';
import { SalesOfficeSidebarComponent } from './shared/sales-office-sidebar/sales-office-sidebar.component';
import { TopNavComponent } from './shared/top-nav/top-nav.component';
import {APP_BASE_HREF, DatePipe} from '@angular/common';
import { ContactComponent } from './contact/contact.component';
import { ContactListComponent } from './contact/contact-list/contact-list.component';
import { AddContactComponent } from './contact/add-contact/add-contact.component';
import { EditContactComponent } from './contact/edit-contact/edit-contact.component';
import { UserComponent } from './user/user.component';
import { AddUserComponent } from './user/add-user/add-user.component';
import { EditUserComponent } from './user/edit-user/edit-user.component';
import { UserListComponent } from './user/user-list/user-list.component';
import { ActivityComponent } from './activity/activity.component';
import { ShowActivityComponent } from './activity/show-activity/show-activity.component';
import { SettingComponent } from './setting/setting.component';
import { UserprofileComponent } from './setting/userprofile/userprofile.component';
import { CompanyProfileComponent } from './setting/company-profile/company-profile.component';
import { MobileComponent } from './mobile/mobile.component';
import { MobileListComponent } from './mobile/mobile-list/mobile-list.component';
import { AddMobileComponent } from './mobile/add-mobile/add-mobile.component';
import { EditMobileComponent } from './mobile/edit-mobile/edit-mobile.component';
import { AdminTopNavComponent } from './shared/admin-top-nav/admin-top-nav.component';
import { SuperAdminComponent } from './super-admin/super-admin.component';
import { SAddCustomerComponent } from './super-admin/s-add-customer/s-add-customer.component';
import { SEditCustomerComponent } from './super-admin/s-edit-customer/s-edit-customer.component';
import { SCustomerListComponent } from './super-admin/s-customer-list/s-customer-list.component';
import { SUserListComponent } from './super-admin/s-user-list/s-user-list.component';
import { SAddUserComponent } from './super-admin/s-add-user/s-add-user.component';
import { SEditUserComponent } from './super-admin/s-edit-user/s-edit-user.component';
import { ChangePasswordComponent } from './super-admin/change-password/change-password.component';
import { FactoringLanguageComponent } from './super-admin/factoring-language/factoring-language.component';
import { AdminHeaderNavigationComponent } from './shared/admin-header-navigation/admin-header-navigation.component';

 
import { ToastrModule } from 'ngx-toastr';
import { NgxLoadingModule } from 'ngx-loading';
import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SViewCustomerComponent } from './super-admin/s-view-customer/s-view-customer.component';
import {NgxMaskModule} from 'ngx-mask';
import { RedirectComponent } from './redirect/redirect.component'
import { ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ActivateGuard } from './services/activate.guard';
import { AuthService } from './services/auth.service';
import {DataTableModule} from "angular-6-datatable";


import { UploadsComponent } from './uploads/uploads.component';
import { FileUploadModule } from 'ng2-file-upload';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { RoleComponent } from './role/role.component';
import { ViewUserComponent } from './user/view-user/view-user.component';
import { FactoringComponent } from './factoring/factoring.component';
import { FactoringTab1Component } from './factoring/factoring-tab1/factoring-tab1.component';
import { FactoringTab2Component } from './factoring/factoring-tab2/factoring-tab2.component';
import { FactoringTab3Component } from './factoring/factoring-tab3/factoring-tab3.component';
import { HighAlertComponent } from './activity/high-alert/high-alert.component';
import { FactoringInvoiceComponent } from './mobile/factoring-invoice/factoring-invoice.component';
import { FileMergeComponent } from './mobile/file-merge/file-merge.component';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BnNgPdfViewerModule } from 'bn-ng-pdf-viewer';

import { FilterPipe } from './_pipe/filter.pipe';
import { DragDropComponent } from './drag-drop/drag-drop.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DownloadComponent } from './download/download.component';
import { DownloadFileComponent } from './download/download-file/download-file.component';
import { DisableNotificationComponent } from './download/disable-notification/disable-notification.component';
import { CustomerSOAListComponent } from './customer/customer-soa-list/customer-soa-list.component';
import { EmailFilesFactoringComponent } from './mobile/email-files-factoring/email-files-factoring.component';
import { LoadsComponent } from './loads/loads.component';
import { ServicingComponent } from './servicing/servicing.component';
import { CreditRequestComponent } from './credit-request/credit-request.component';
import { TwoDigitDecimaNumberDirective } from './two-digit-decima-number.directive';
import { SSettingsComponent } from './super-admin/s-settings/s-settings.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true
};
const config: InputFileConfig = {
  fileAccept: '*',
  fileLimit: 8
};
@NgModule({
    declarations: [
        AppComponent,
        SpinnerComponent,
        FullComponent,
        NavigationComponent,
        BreadcrumbComponent,
        LoginComponent,
        CustomerComponent,
        CustomerListComponent,
        AddCustomerComponent,
        EditCustomerComponent,
        SignupComponent,
        SalesOfficeSidebarComponent,
        TopNavComponent,
        FilterPipe,
        ContactComponent,
        ContactListComponent,
        AddContactComponent,
        EditContactComponent,
        UserComponent,
        AddUserComponent,
        EditUserComponent,
        UserListComponent,
        ActivityComponent,
        ShowActivityComponent,
        SettingComponent,
        UserprofileComponent,
        CompanyProfileComponent,
        MobileListComponent,
        AddMobileComponent,
        EditMobileComponent,
        MobileComponent,
        AdminTopNavComponent,
        SuperAdminComponent,
        SAddCustomerComponent,
        SEditCustomerComponent,
        SCustomerListComponent,
        SUserListComponent,
        SAddUserComponent,
        SEditUserComponent,
        ChangePasswordComponent,
        FactoringLanguageComponent,
        AdminHeaderNavigationComponent,
        SViewCustomerComponent,
        RedirectComponent,
        UploadsComponent,
        RoleComponent,
        ViewUserComponent,
        FactoringComponent,
        FactoringTab1Component,
        FactoringTab2Component,
        FactoringTab3Component,
        HighAlertComponent,
        FactoringInvoiceComponent,
        FileMergeComponent,
        DragDropComponent,
        ForgotPasswordComponent,
        DownloadComponent,
        DownloadFileComponent,
        DisableNotificationComponent,
        CustomerSOAListComponent,
        EmailFilesFactoringComponent,
        LoadsComponent,
        ServicingComponent,
        CreditRequestComponent,
        TwoDigitDecimaNumberDirective,
        SSettingsComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        FileUploadModule,
        NgbModule.forRoot(),
        ToastrModule.forRoot({
           timeOut: 2000,
           positionClass: 'toast-top-center',
           preventDuplicates: true,
        }),
        NgxLoadingModule.forRoot({}),
        NgxMaskModule.forRoot(),
        ReactiveFormsModule,
        NgxSpinnerModule,
        Ng4LoadingSpinnerModule.forRoot() ,
        NgMultiSelectDropDownModule.forRoot(),
        DataTableModule,
        PdfViewerModule,
        BnNgPdfViewerModule,
        OwlDateTimeModule, 
        OwlNativeDateTimeModule,
        RouterModule.forRoot(Approutes, { useHash: false }),
        PerfectScrollbarModule,
        DataTablesModule,
        InputFileModule.forRoot(config),
        MatToolbarModule,
        SweetAlert2Module.forRoot({
          buttonsStyling: false,
          customClass: 'modal-content',
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn'
        }),
        CollapseModule.forRoot(), BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        SortableModule.forRoot(),
        BsDatepickerModule.forRoot(),
        DatepickerModule.forRoot()
    ],
    providers: [
        {
          provide: PERFECT_SCROLLBAR_CONFIG,
          useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        {
          provide: LocationStrategy,
          useClass: PathLocationStrategy
        },
        DatePipe,
        ActivateGuard,EncrDecrService,AuthService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
